
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Settings, Stethoscope, Info } from 'lucide-react';
import EnabledServicesPreview from './EnabledServicesPreview';
import { Treatment } from '@/data/treatmentData';

interface ServiceVisibilityCardProps {
  dentalTreatments: Treatment[];
  cosmeticTreatments: Treatment[];
}

const ServiceVisibilityCard: React.FC<ServiceVisibilityCardProps> = ({
  dentalTreatments,
  cosmeticTreatments,
}) => {
  const enabledDentalTreatments = dentalTreatments.filter(t => t.enabled);
  const enabledCosmeticTreatments = cosmeticTreatments.filter(t => t.enabled);
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Service Visibility Preview</CardTitle>
        <CardDescription>
          How your services will appear to patients on your profile
        </CardDescription>
      </CardHeader>
      <CardContent>
        {enabledDentalTreatments.length === 0 && enabledCosmeticTreatments.length === 0 ? (
          <div className="border border-dashed border-muted-foreground/30 rounded-md p-6 text-center">
            <Info className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
            <h3 className="text-lg font-medium mb-1">No Services Selected</h3>
            <p className="text-sm text-muted-foreground">
              Enable some services above to see how they will appear on your profile
            </p>
          </div>
        ) : (
          <Tabs defaultValue="dental">
            <TabsList className="grid w-full grid-cols-2 mb-4">
              <TabsTrigger value="dental" className="flex items-center gap-2">
                <Stethoscope className="h-4 w-4" />
                <span>Dental Services</span>
                <span className="bg-primary/10 text-primary px-1.5 py-0.5 rounded-full text-xs">
                  {enabledDentalTreatments.length}
                </span>
              </TabsTrigger>
              <TabsTrigger value="cosmetic" className="flex items-center gap-2">
                <Settings className="h-4 w-4" />
                <span>Cosmetic Services</span>
                <span className="bg-primary/10 text-primary px-1.5 py-0.5 rounded-full text-xs">
                  {enabledCosmeticTreatments.length}
                </span>
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="dental">
              <EnabledServicesPreview services={enabledDentalTreatments} />
            </TabsContent>
            
            <TabsContent value="cosmetic">
              <EnabledServicesPreview services={enabledCosmeticTreatments} />
            </TabsContent>
          </Tabs>
        )}
      </CardContent>
    </Card>
  );
};

export default ServiceVisibilityCard;
